import React from 'react'
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer"
import Navbar from '../../../../components/Navbar/Navbar';
import { developerGodrej ,Headers} from '../../../../data/projects/Godrej/data';  // Adjust the path based on your file structure
import DevelopersPageComponent from '../../../../components/body/topDevelopersComponents/developerspageComponent/developersPageComponent'
import DeveloperPageHeaderComponent from '../../../../components/body/topDevelopersComponents/developerspageComponent/DeveloperPageHeaderComponent';
import { groupProperties } from "../../../../components/body/topDevelopersComponents/filterproperty";

const GodrejDeveloper = () => {
    const isState = 1; // Change to 0 if you want to group by location instead of state

    // Safeguard: Ensure developers.properties is an array
    const properties = developerGodrej?.properties || [];
  
    // Group properties based on isState flag
    const groupedProperties = groupProperties(properties, isState);
  
    return (
      <div>
        <Navbar />
        <DeveloperPageHeaderComponent Headers={Headers} />
  
        {/* Render properties based on grouping condition */}
        <div className="">
          {Object.entries(groupedProperties).map(([key, properties]) => (
            <div key={key}>
              {/* Render DevelopersPageComponent with filtered data */}
              <DevelopersPageComponent
                developersData={properties}
                heading={`${properties[0]?.developer} Properties in ${key}`}
              />
            </div>
          ))}
        </div>
  
        <Main_Footer />
      </div>
    );
}

export default GodrejDeveloper